/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Denied_TitleInputs */

const en_agent_authorization_denied_title = /** @type {(inputs: Agent_Authorization_Denied_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authorization request rejected`)
};

const zh_agent_authorization_denied_title = /** @type {(inputs: Agent_Authorization_Denied_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已拒绝授权请求`)
};

/**
* | output |
* | --- |
* | "Authorization request rejected" |
*
* @param {Agent_Authorization_Denied_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_denied_title = /** @type {((inputs?: Agent_Authorization_Denied_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Denied_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_denied_title(inputs)
	return zh_agent_authorization_denied_title(inputs)
});
export { agent_authorization_denied_title as "agent.authorization.denied_title" }